import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml:
    "Play the volume V<sub>ab</sub> and the losses R<sub>ab</sub> of the speaker's enclosure to see their effects on the frequency response curves. These parameters can be tuned as a function of the equivalent volume of the speaker V<sub>as</sub> and its loss term R<sub>as</sub>.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 9],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Closed-box system",
                  scrollbars: false,
                  formatter: "simple",
                  styles: {
                    textTransform: "uppercase",
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                    lineHeight: "22px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "iframe",
                options: {
                  src: `${config.IFRAMES_REACT_URL}/0420/`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
